import { AlenScheduleDays } from "src/interfaces/IProgram";
import { AlenShadow } from "src/services/alen/alenDeviceConfig/utils";
import { WRITABLE_PRODUCT_TYPES } from "src/services/alen/utils";

export enum ScheduleTargetLevel {
  PROPERTY = "ALL",
  FLOOR = "SUB_LOCATION",
  DEVICE_TYPE = "PRODUCT_NAME",
  DEVICE = "INDIVIDUAL",
}

export function convertToScheduleTargetLevel(
  value: "ALL" | "SUB_LOCATION" | "PRODUCT_NAME" | "INDIVIDUAL"
): ScheduleTargetLevel {
  switch (value) {
    case "ALL":
      return ScheduleTargetLevel.PROPERTY;
    case "SUB_LOCATION":
      return ScheduleTargetLevel.FLOOR;
    case "PRODUCT_NAME":
      return ScheduleTargetLevel.DEVICE_TYPE;
    case "INDIVIDUAL":
      return ScheduleTargetLevel.DEVICE;
    default:
      throw new Error(`Unknown value: ${value}`);
  }
}

export type ScheduleTargetSelection = {
  level: ScheduleTargetLevel;
  value: string[];
};

type DeviceGroupType = "PRODUCT_NAME" | "SUB_LOCATION" | "INDIVIDUAL" | "ALL";
export type DeviceGroup = {
  deviceGroupName: typeof WRITABLE_PRODUCT_TYPES[number];
  deviceDetails: {
    productId: string;
    deviceIds: string[];
  }[];
};

export type SchedulableAction = Omit<AlenShadow, "filter_life">;

export type ScheduleDto = {
  deviceSchedulerId?: number;
  locationId: number;
  schedulerName?: string;
  schedulerType: "BULK" | "INDIVIDUAL";
  schedulerCode?: string;
  timezone?: string;
  timezoneId?: string;
  actionCode?: keyof SchedulableAction;
  actionStartTime?: string;
  actionStartValue?: SchedulableAction[keyof SchedulableAction];
  actionEndTime?: string;
  actionEndValue?: SchedulableAction[keyof SchedulableAction];
  frequency: {
    repeat: "CUSTOM" | "DAILY";
    days: AlenScheduleDays[];
  };
  deviceGroupType?: DeviceGroupType;
  deviceGroups: DeviceGroup[];
};

export type UpdateScheduleStatusDto = {
  deviceSchedulerId: number;
  enabled: boolean;
  cancelNextRun: boolean;
  deleted: boolean;
};
